window.addEventListener('DOMContentLoaded', () => {

  let pdqWidgetCounter = 0;

  const pdqWidgetInterval = setInterval(() => {

    const pdqWidget = document.querySelector('pdqproductpromise');

    if (!!pdqWidget) {

      const previousElement = document.querySelector('[id*="js-product-form__error-message--"]');

      previousElement?.insertAdjacentElement('afterend', pdqWidget.parentElement);
      clearInterval(pdqWidgetInterval)

    }
    else if (!!!pdqWidget && pdqWidgetCounter < 150) pdqWidgetCounter += 1
    else clearInterval(pdqWidgetInterval)

  }, 50);

})
